
export default {
  data() {
    return {
      search: '',
    }
  },
  methods: {
    SET_SEARCH_FROM_QUERY() {
      const q = this.$route.query.q
      if (q) this.search = q
    },
  },
  created() {
    this.SET_SEARCH_FROM_QUERY()
  },
}
